import { render, staticRenderFns } from "./PayAuthority.vue?vue&type=template&id=27296bb8"
import script from "./PayAuthority.vue?vue&type=script&lang=ts"
export * from "./PayAuthority.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports